import React, { FC } from "react";
import Button from "@mui/material/Button";
import DeleteIcon from "@mui/icons-material/Delete";
import styled from "styled-components";
import { CHANNEL_COVER_BACKGROUND_STYLES } from "@Utils/channelCover";

interface ImageDraftProps {
    draftImage: any;
    onRemoveDraftCover: () => void;
}

const Container = styled.div<{
    draftImage?: any;
    key?: string;
}>`
    position: relative;
    height: 100%;
    width: 100%;
    background-size: ${CHANNEL_COVER_BACKGROUND_STYLES.backgroundSize};
    background-repeat: ${CHANNEL_COVER_BACKGROUND_STYLES.backgroundRepeat};
    background-position: ${CHANNEL_COVER_BACKGROUND_STYLES.backgroundPosition};

    ${({ draftImage }) =>
        draftImage ? `background-image: url(${draftImage.src}) ` : ""}
`;

const CoverDraft: FC<ImageDraftProps> = ({
    draftImage,
    onRemoveDraftCover,
}) => {
    return (
        draftImage && (
            <Container key={draftImage.id} draftImage={draftImage}>
                <Button
                    onClick={onRemoveDraftCover}
                    sx={{
                        position: "absolute",
                        right: 0,
                        zIndex: 1,
                        p: "4px",
                        minWidth: "unset",
                        color: "grey.500",
                    }}
                >
                    <DeleteIcon />
                </Button>
            </Container>
        )
    );
};

export default CoverDraft;
